import { getSessionCookie } from './session';
import { ANALYTICS_API_URL } from '../constants/variables';
import { config } from '../constants/domainConfig';

export const sendData = (cName, cCategory, cType, uType, additionalParams) => {
    const sessionId = getSessionCookie();
    const subDomain = config.subDomain;
    const args = {
        url: window.location.href,
        lang: config.lang,
        userAgent: navigator.userAgent
    }
    const authorizationData = JSON.parse(sessionStorage.getItem('authorized'));
    let rockmanId = authorizationData ? authorizationData.subscriptionData ? authorizationData.subscriptionData.rockmanId || authorizationData.subscriptionData.rockman_id : '' : ''; 
    let rid = new URL(window.location.href).searchParams.get('rid')
    if( (rockmanId && rockmanId.length > 0) || (rid && rid.length > 0) ){
        const data = {
            r: rockmanId && rockmanId.length >  0 ? rockmanId : rid,
            portal_session_id: sessionId,
            d: [
                {
                    t: "content_usage",
                    a: {
                        content_name: cName,
                        content_category: cCategory,
                        content_type: cType,
                        usage_type: uType,
                        args: {...args, ...additionalParams},
                        product_name: window.location.hostname.includes("gamiclub") ? "gamiclub" : window.location.hostname.includes("beemobi") ? "beemobi" : window.location.hostname.includes("appspool") ? "appspool" : window.location.hostname.includes("vplay") ? "vplay" : window.location.hostname.includes('gamezclan') ? 'gamezclan' : window.location.hostname.includes('thegamingclubs') ? 'thegamingclubs' : "gamelords",
                        subdomain: subDomain
                    }
                }
            ]
        };
        if(window.location.host.includes('localhost')){
            console.log(data);
            return;
        }
        var xhr = new XMLHttpRequest();
        xhr.open('POST', ANALYTICS_API_URL, true);
        // xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify(data));
    }
    return;
}


// WEBPACK FOOTER //
// ./src/analytics/sendData.js